@if (assetsStatus !== 'loading') {
  <table
    mat-table
    [dataSource]="assetLibraryList"
    matSort
    (matSortChange)="onMatSortChange()"
    >
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Name
        <span class="sort-icon sort-up"></span>
        <span class="sort-icon sort-down"></span>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="image-info-block" [ngClass]="{ 'can-select': canSelect }">
          @if (checkPreviewImg(element.format, element.src)) {
            <div
              class="image-preview"
          [ngStyle]="{
            background: 'url(' + element.src + ') no-repeat center center',
            'background-size': 'cover'
          }"
              observeVisibility
              scaleImgToCanvas
              scaleImgSrc="{{element.src}}"
              [scaleImgTrigger]="element.loadImg"
              [debounceTime]="100"
              [threshold]="0.1"
              [attr.name]="element.name"
              [attr.id]="element.id"
              (visible)="element.loadImg = $event"
              >
            </div>
          } @else {
            <div class="no-preview-block">
              <img [src]="setNoPreviewImg(element.format).src" [alt]="element.name" width="40" />
              @if (setNoPreviewImg(element.format).type) {
                <p class="no-preview-format">
                  {{ setNoPreviewImg(element.format).type }}
                </p>
              }
            </div>
          }
          <div class="image-name">
            <span class="fileName" [innerHTML]="searchMark(element.name)"></span>
          </div>
        </div>
      </td>
    </ng-container>
      <ng-container matColumnDef="format">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          File Format
          <span class="sort-icon sort-up"></span>
          <span class="sort-icon sort-down"></span>
        </th>
        <td
          mat-cell
          *matCellDef="let element"
          class="format"
          >
          <span class="fileName" [innerHTML]="searchMark(element.format)"></span>
        </td>
      </ng-container>
      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Size
          <span class="sort-icon sort-up"></span>
          <span class="sort-icon sort-down"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="fileName" [innerHTML]="searchMark(setFilesize(element.size))"></span>
        </td>
      </ng-container>
      <ng-container matColumnDef="resolution">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Resolution
          <span class="sort-icon sort-up"></span>
          <span class="sort-icon sort-down"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="fileName" [innerHTML]="searchMark(element.resolution)"></span>
        </td>
      </ng-container>
      <ng-container matColumnDef="uploaded">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Date Uploaded
          <span class="sort-icon sort-up"></span>
          <span class="sort-icon sort-down"></span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="fileName" [innerHTML]="searchMark(setDate(element.uploaded))"></span>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <div class="image-actions">
            <button
              class="action edit"
              [ngClass]="setActiveStyles('edit', element.id)"
              [disabled]="!canEditAssets()"
              matTooltip="Edit name and description"
              matTooltipPosition="above"
            ></button>
            <button
              class="action preview"
              [ngClass]="setActiveStyles('preview', element.id)"
              [disabled]="!checkPreviewImg(element.format, element.src)"
            ></button>
            <button
              class="action remove"
              [ngClass]="setActiveStyles('remove', element.id)"
              [disabled]="!canEditAssets()"
            ></button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        (click)="selectAsset(element.id)"
        *matRowDef="let row; let element; columns: displayedColumns"
        [class.active]="activeAction.id === element.id"
        [ngStyle]="{ cursor: canSelect ? 'pointer' : 'auto' }"
        [attr.data-name]="element.name"
        [attr.data-id]="element.id"
      ></tr>
    </table>
  } @else {
    <loading-icon></loading-icon>
  }

  @if (assetsStatus !== 'loading') {
    <div
      observeVisibility
      [debounceTime]="100"
      [threshold]="0.1"
      (visible)="onVisible()"
      id="lazy-loading-trigger"
    ></div>
  }

  @if (loadMore) {
    <div class="loading-more"><loading-icon></loading-icon></div>
  }

  @if (showPopup()) {
    <div class="popup-container">
      <div class="popup-block">
        <div class="popup-header">
          <div class="close-btn" (click)="clearActiveAction()"></div>
        </div>
        <div class="popup-body">
          @if (activeAction.action === 'preview') {
            <img
              [src]="activeAction.item.src"
              [alt]="activeAction.item.name"
              class="preview"
              />
          }
          @if (activeAction.action === 'edit') {
            <form [formGroup]="updateAssetForm" class="edit-asset-block">
              <h4 class="edit-asset-title">Edit asset details</h4>
              <div class="edit-field">
                <label for="assetName" class="edit-field-label">
                  Name <span class="required-asterisk">*</span>
                </label>
                <input
                  id="assetName"
                  type="text"
                  class="edit-field-input"
                  formControlName="name"
                  [maxlength]="maxNameLength"
                  (click)="editImageInputClick($event)"
                  />
                <div class="edit-field-meta">
                  <span class="edit-field-count">{{ (updateAssetForm.get('name').value || '').length }}/{{ maxNameLength }}</span>
                </div>
                @if (updateAssetForm.get('name').invalid && updateAssetForm.get('name').touched) {
                  <p class="error-msg">{{ getValidationError() }}</p>
                }
              </div>
              <div class="edit-field">
                <label for="assetDescription" class="edit-field-label">
                  Description <span class="required-asterisk">*</span>
                </label>
                <textarea
                  id="assetDescription"
                  class="edit-field-input edit-field-textarea"
                  formControlName="description"
                  [maxlength]="maxDescriptionLength"
                  (click)="editImageInputClick($event)"
                  rows="3"
                ></textarea>
                <div class="edit-field-meta">
                  <span class="edit-field-count">{{ (updateAssetForm.get('description').value || '').length }}/{{ maxDescriptionLength }}</span>
                </div>
                @if (updateAssetForm.get('description').invalid && updateAssetForm.get('description').touched) {
                  <p class="error-msg">Description is required (max {{ maxDescriptionLength }} characters)</p>
                }
              </div>
              <div class="buttons-block">
                <button type="button" class="cancel-btn" (click)="closeAssetEditionHandler($event)">Cancel</button>
                <button
                  type="button"
                  class="confirm-btn"
                  [disabled]="updateAssetForm.invalid"
                  (click)="updateAssetHandler(activeAction.id, $event)"
                  >
                  Save
                </button>
              </div>
            </form>
          }
          @if (activeAction.action === 'remove') {
            <div class="remove-block">
              <h4 class="remove-title">You are about to delete:</h4>
              <div class="info-block">
                @if (
                  checkPreviewImg(activeAction.item.format, activeAction.item.src)) {
                  <img
                    [src]="activeAction.item.src"
                    [alt]="activeAction.item.name"
                    class="preview"
                    />
                } @else {
                  <div class="no-preview-block">
                    <img
                      [src]="setNoPreviewImg(activeAction.item.format).src"
                      [alt]="activeAction.item.name"
                      width="40"
                      />
                      @if (setNoPreviewImg(activeAction.item.format).type) {
                        <p class="no-preview-format">
                          {{ setNoPreviewImg(activeAction.item.format).type }}
                        </p>
                      }
                    </div>
                  }
                  <div class="info-right-panel">
                    <table class="info-table">
                      <tr>
                        <td class="info-table-left">Name:</td>
                        <td class="info-table-right" matTooltipClass="assetTooltip" #tt="matTooltip" appTruncateWithTooltip
                          matTooltipPosition="above" [matTip]="tt"
                        tooltipText="'{{activeAction.item.name + '.' + activeAction.item.type}}'" matTooltip=""></td>
                      </tr>
                      <tr>
                        <td class="info-table-left">Size:</td>
                        <td class="info-table-right">{{ setFilesize(activeAction.item.size) }}</td>
                      </tr>
                      <tr>
                        <td class="info-table-left">Format:</td>
                        <td class="info-table-right">{{ activeAction.item.format }}</td>
                      </tr>
                      <tr>
                        <td class="info-table-left">Resolution:</td>
                        <td class="info-table-right">{{ activeAction.item.resolution }}</td>
                      </tr>
                    </table>
                    <div class="info-warn-message">
                      <div class="warn-icon"></div>
                      <p class="warn-desc">
                        Check and confirm the file isn't actively being used. Once deleted
                        <span>it cannot be restored.</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="buttons-container">
                  <mat-checkbox class="confirm-checkbox" [(ngModel)]="confirm">
                    I understand and confirm.
                  </mat-checkbox>
                  <div class="buttons-block">
                    <button class="cancel-btn" (click)="clearActiveAction()">Cancel</button>
                    <button class="delete-btn" (click)="removeAssetHandler($event)" [disabled]="!confirm">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }

